import styled, { css } from 'styled-components';
import { DownOutlined, MinusOutlined } from '@ant-design/icons';

export const AntCard = styled.div.attrs({ className: 'ant-card' })`
  margin: 0 0 1rem 0;
`;

export const AntCardHead = styled.div.attrs({ className: 'ant-card-head' })`
  position: relative;
  cursor: pointer;
`;
export const AntCardHeadWrapper = styled.div.attrs({ className: 'ant-card-head-wrapper' })``;
export const AntCardHeadTitle = styled.div.attrs({ className: 'ant-card-head-title' })``;
export const AntCardBody = styled.div.attrs({ className: 'ant-card-body' })``;

const iconBase = css`
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
`;

export const DownIcon = styled(DownOutlined)`
  ${iconBase}
`;

export const MinusIcon = styled(MinusOutlined)`
  ${iconBase}
`;
